import { AbstractMaterialFactory } from "oc-threejs/loader/AbstractMaterialFactory";
import { SceneNode } from "./SceneNode";
import { Material } from "three";

export class NodeMaterialFactory extends AbstractMaterialFactory {
  missingMaterialsLogged = new Set<String>();
  sceneNode: SceneNode;

  constructor(texture_root: string, sceneNode: SceneNode) {
    super(texture_root);
    this.sceneNode = sceneNode;
  }

  _createMaterial(materialName: string): Material {
    const node = this.sceneNode.findMaterialJson(materialName);
    if (node && !node.initCalled) {
      node.init();
    }
    const material3d = node?.threeValue;
    if (material3d == null) {
      if (!this.missingMaterialsLogged.has(materialName)) {
        this.missingMaterialsLogged.add(materialName);
        console.warn("Material does not exist, it will be white:", materialName);
      }
    }

    return material3d;
  }
}
